import { z } from "zod";
import { DbCreateInputOmit, DbUpdate, nullishToOptional } from "../helpers";
import { OmitStrict } from "../utils";

export const DesignSystemVersion = z.object({
  id: z.string(),
  version: z.string(),
  createdAt: z.coerce.date(),
  designSystemId: z.string(),
  name: z.string(),
  comment: z.string(),
  isReadonly: z.boolean(),
  changeLog: z.string(),
  parentId: z.string().optional(),
  isDraftsFeatureAdopted: z.boolean(),
});

export type DesignSystemVersion = z.infer<typeof DesignSystemVersion>;

export type CreateDesignSystemVersion = DbCreateInputOmit<DesignSystemVersion>;

export type UpdateDesignSystemVersion = OmitStrict<
  DbUpdate<DesignSystemVersion>,
  "designSystemId" | "isReadonly" | "version" | "parentId"
>;

// Jobs
export const VersionCreationJobStatus = z.enum(["Success", "InProgress", "Error"]);

export type VersionCreationJobStatus = z.infer<typeof VersionCreationJobStatus>;

export const VersionCreationJob = z.object({
  id: z.string(),
  version: z.string(),
  designSystemId: z.string(),
  designSystemVersionId: nullishToOptional(z.string()),
  status: VersionCreationJobStatus,
  errorMessage: nullishToOptional(z.string()),
});

export type VersionCreationJob = z.infer<typeof VersionCreationJob>;
